import React, { Fragment, FC } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { SimpleTheoreticalFormAnswerDto } from 'stores/events/theoretical-form-store';
import { CountryFlag } from 'widgets/bussiness/country-flag';

interface TailwindTheoreticalEmployeeTableProps extends WithTranslation {
  theoreticalFormAnswers: SimpleTheoreticalFormAnswerDto[];
  currentUserId: string;
}

const TailwindTheoreticalEmployeeTable: FC<TailwindTheoreticalEmployeeTableProps> = ({ t, theoreticalFormAnswers, currentUserId }) => {
  return (
    <div onClick={() => {}} className={`w-full bg-white shadow p-4 mt-4 overflow-y-auto transition-all duration-300 max-h-[300px]`}>
      <div className="mb-3"></div>
      {(theoreticalFormAnswers || [])
        .filter(({ userId }) => userId === currentUserId)
        .map(form => {
          if (!form) return null;
          const { user, id, userId, averageTime, result, totalQuestions, totalTime, questionsAnswered } = form;
          return (
            <div key={`theoretical-table__${id}-${userId}`} className="border-l-4 p-3 mb-2 cursor-pointer shadow-md">
              <div className="flex justify-between items-center">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h4 className="text-black-600 font-semibold">{`${user.firstName}  ${user.lastName}`}</h4>
                  </div>
                  <p className="text-xs text-gray-500">{user.userName}</p>
                  <p className="text-sm">
                    {user.location ? (
                      <>
                        <CountryFlag countryName={user.location.countryName} />
                        {` ${user.location.location}`}
                      </>
                    ) : (
                      '-'
                    )}
                  </p>
                  <p className="text-sm">
                    {t('Average Time')}: {averageTime ? averageTime : '-'}
                  </p>
                  <p className="text-sm">
                    {t('Total Time')}: {totalTime ? totalTime : '-'}
                  </p>
                  <p className="text-sm">
                    {t('Result')}: {result != null && result !== 0 ? `${result} %` : '-'}
                  </p>
                  <p className="text-sm">
                    {t('Number of Questions')}:
                    {questionsAnswered == null || questionsAnswered === 0 ? '-' : `${questionsAnswered}/${totalQuestions}`}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default withTranslation()(TailwindTheoreticalEmployeeTable);
